import React from 'react'
import styles from './GraphCard.module.sass'
import { Bar } from 'react-chartjs-2'
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js'
import useTrans from '@hooks/useTrans'
import { MetricaType } from '@gql/graphql'
import useIsMobile from '@hooks/useIsMobile'

interface Props {
  className?: string
  metrica: MetricaType
}

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend)

const GraphCard = (props: Props) => {
  const { className = '', metrica } = props

  const t = useTrans()
  const isMobile = useIsMobile()

  const years = metrica.valori.map((x) => x.anno).slice(-3)
  const values = metrica.valori.map((x) => x.valore).slice(-3)

  const data = {
    labels: years,
    datasets: [
      {
        label: t(metrica?.name),
        data: values,
        backgroundColor: '#75DF73',
        hoverBackgroundColor: '#35BB33',
        barPercentage: 0.6,
      },
    ],
  }

  const options = {
    responsive: true,
    plugins: {
      legend: {
        display: false,
      },
      title: {
        display: true,
        text: t(metrica?.name),
        color: '#161616',
        font: {
          size: !isMobile ? 26 : 13.5,
          weight: 'bold',
        },
      },
      tooltip: {
        displayColors: false,
        backgroundColor: `#161616`,
        titleFont: {
          size: !isMobile ? 14 : 7.5,
        },
        bodyFont: {
          size: !isMobile ? 14 : 7.5,
        },
        callbacks: {
          title: (tooltipItems) => {
            const label = tooltipItems[0].label
            return `${t('Anno')} ${label}`
          },
          label: (tooltipItem) => {
            const value = tooltipItem.raw
            return `${value}€`
          },
        },
      },
    },
    scales: {
      x: {
        grid: {
          color: '#C7BBB7',
        },
        ticks: {
          color: '#161616',
          font: {
            size: !isMobile ? 16 : 8.5,
          },
        },
      },
      y: {
        grid: {
          color: '#C7BBB7',
        },
        ticks: {
          color: '#161616',
          font: {
            size: !isMobile ? 16 : 8.5,
          },
          stepSize: 50,
          callback: (value: number) => value.toFixed(2).replace('.', ','),
        },
        grace: '5%',
      },
    },
  } as const

  t('awndwandiwandwandinwadinwadindia')

  return metrica ? (
    <div className={`${styles.root} ${className}`}>
      <Bar data={data} options={options} className={styles.bar} />
    </div>
  ) : (
    <></>
  )
}

export default GraphCard
